import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'
import { ActiveSessionsTableHead } from './ActiveSessionsTableHead'

/** @param {{ rows: { id: string, device: string, created: string }[] }} props */
export function ActiveSessionsTableBody({ rows }) {
  return (
    <TableContainer component={Paper} elevation={0} className={shared.tableContainerPaper}>
      <Box className={shared.tableInnerClip}>
        <Table size="small" className={shared.tableRoot}>
          <ActiveSessionsTableHead />
          <TableBody>
            {rows.map((row, rowIndex) => {
              const isLast = rowIndex === rows.length - 1
              return (
                <TableRow key={row.id} hover className={`${shared.tableBodyRow}${isLast ? ` ${shared.tableBodyRowLast}` : ''}`}>
                  <TableCell className={shared.tdCell}>
                    <Typography variant="body2" color="text.primary" className={shared.userName}>{row.device}</Typography>
                  </TableCell>
                  <TableCell className={shared.tdCell}>
                    <Typography variant="body2" color="text.secondary">{row.created}</Typography>
                  </TableCell>
                  <TableCell align="right" className={shared.tdCellActions}>
                    <Button variant="outlined" size="small" onClick={() => {}}>Revoke</Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  )
}
